import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Form } from 'antd';
import InputComponent from '@/components/Input';
import ButtonComponent from '@/components/Button';
import { ReactComponent as SaveIcon } from '@/assets/images/icons/save_icon.svg';
import './index.scss';
import { useTranslation } from 'react-i18next';

function ModalSecurityComponent({ open, onClose, onFinish }) {
  const [loadingBtnSubmit, setLoadingBtnSubmit] = useState(false);
  const { t } = useTranslation();
  const [formInstance] = Form.useForm();
  const handeUpdatePassword = async (values) => {
    setLoadingBtnSubmit(true);
    const { success } = await onFinish(values);
    if (success) {
      formInstance.resetFields();
      onClose();
    }
    setLoadingBtnSubmit(false);
  };

  const handleOnChangePassword = () => {
    formInstance.resetFields(['confirmPassword']);
  };

  return (
    <Drawer
      title={t('login.btn_change_password')}
      className="drawer"
      placement="right"
      onClose={onClose}
      open={open}
      width={573}
      destroyOnClose
    >
      <Form
        className="security-form"
        name="security-form"
        onFinish={handeUpdatePassword}
        style={{
          maxWidth: 600,
        }}
        form={formInstance}
      >
        <Form.Item
          name="currentPassword"
          label={t('profile_page.form.fields.current_password')}
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: t('profile_page.errols.current_password.require'),
            },
          ]}
        >
          <InputComponent
            placeholder={t('profile_page.placehoder.current_password')}
            type="password"
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={t('profile_page.form.fields.new_password')}
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: t('login.form.errors.password.required'),
            },
            {
              min: 6,
              message: t('sign_up.form.errors.new_password.invalid_value'),
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (
                  !value ||
                  !getFieldValue('confirmPassword') ||
                  getFieldValue('confirmPassword') === value
                ) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t('sign_up.form.errors.confirm_password.not_match'),
                  ),
                );
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('currentPassword') !== value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t('profile_page.errols.new_password.invalid_value'),
                  ),
                );
              },
            }),
          ]}
        >
          <InputComponent
            placeholder={t('profile_page.placehoder.new_password')}
            type="password"
            onChange={handleOnChangePassword}
          />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label={t('profile_page.form.fields.confirm_password')}
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: t('profile_page.errols.confirm_password.require'),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t('sign_up.form.errors.confirm_password.not_match'),
                  ),
                );
              },
            }),
          ]}
        >
          <InputComponent
            placeholder={t('profile_page.placehoder.confirm_password')}
            type="password"
          />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 8,
          }}
        >
          <ButtonComponent
            onClick={onClose}
            className="btn-exit"
            disabled={loadingBtnSubmit}
          >
            {t('profile_page.btn_discard')}
          </ButtonComponent>
          <ButtonComponent
            type="primary"
            htmlType="submit"
            className="btn-saveChanges"
            icon={<SaveIcon />}
            disabled={loadingBtnSubmit}
            loading={loadingBtnSubmit}
          >
            {t('profile_page.btn_save')}
          </ButtonComponent>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

ModalSecurityComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onFinish: PropTypes.func,
};

export default ModalSecurityComponent;
